import {
    // Page, 
    Image,
    Text,
    View
} from '@react-pdf/renderer';

import dayjs from 'dayjs';

import { styles } from '../styles/styles';

import { routeTypes } from '../../../../hooks/useSystemRoutes'

const RenderQrCode = ({ data }) => {

    if (!data) return <></>

    return (
        <View
            style={{
                textAlign: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'flex-end',
            }}
        >
            <Image
                src={data}
                style={{
                    width: 40,
                    height: 40
                }}
            />
        </View>
    )
}

const RenderBodyTopInfoRow = ({ name, value }) => {
    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 3
            }}
        >
            <Text style={[styles.h10, { fontWeight: '800' }]}>
                {name.toUpperCase()}
            </Text>
            <Text style={[styles.h12, {}]}>
                {value}
            </Text>
        </View>
    )
}

// purchase order & sales invoice
export function BodyTopStyle1(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '64%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    BILLING TO:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.profile_name ? document.profile_name : "-"}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.address_1} {document?.address_2}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.area_name} {document?.postcode} ({document?.state_name}, {document?.country_name})
                </Text>
                <Text style={[styles.h9, {}]}>
                    {`${document?.contact}`}
                </Text>
            </View>

            {/* <View
                 style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5 }]}>
                    DELIVER TO:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.delivery_profile_name}
                </Text>
                <Text style={[styles.h9, {  width: '100%' }]}>
                    {document?.delivery_address_1} {document?.delivery_address_2}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.delivery_area_name} {document?.delivery_postcode} ({document?.delivery_state_name}, {document?.delivery_country_name})
                </Text>
            </View> */}

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>

    )

}

// billing & deliver
export function BodyTopStyle2(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    BILLING TO:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.billing_profile_name}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.billing_address_1} {document?.billing_address_2}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.billing_area_name} {document?.billing_postcode} ({document?.billing_state_name}, {document?.billing_country_name})
                </Text>
                {/* <Text style={[styles.h9, { }]}>
                    TEL : 012-8055340
                </Text> */}
            </View>

            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5 }]}>
                    DELIVER TO:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.delivery_profile_name}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.delivery_address_1} {document?.delivery_address_2}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.delivery_area_name} {document?.delivery_postcode} ({document?.delivery_state_name}, {document?.delivery_country_name})
                </Text>
                {/* <Text style={[styles.h9, { }]}>
                    TEL : 012-8055340
                </Text> */}
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>

    )
}

// to only personal
export function BodyTopStyle3(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
        {
            name: "Time",
            value: dayjs(document?.ax_createdatetime).format("h:mm A")
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '64%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    {`TO:  `}
                    <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { marginLeft: 10, width: '100%' }]}>
                        {/* {document?.billing_profile_name} */}
                        {document?.profile_name} ({document?.identity_no})
                    </Text>
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {/* {document?.billing_address_1} {document?.billing_address_2} */}
                    {document?.address_1} {document?.address_2}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {/* {document?.billing_area_name} {document?.billing_postcode} ({document?.billing_state_name}, {document?.billing_country_name}) */}
                    {document?.area_name} {document?.postcode} ({document?.state_name}, {document?.country_name})
                </Text>
                {/* <Text style={[styles.h9, { }]}>
                    TEL : 012-8055340
                </Text> */}
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>
    )
}

// item transfer
export function BodyTopStyle4(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    FROM LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.location_name}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5 }]}>
                    TO LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.to_location_name}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.to_location_address_1} {document?.to_location_address_2}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.to_area} {document?.to_postcode} ({document?.to_state}, {document?.to_country})
                </Text>
                {/* <Text style={[styles.h9, { }]}>
                    TEL : 012-8055340
                </Text> */}
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>
        </View>
    )
}

// item receive & purchase invoice
export function BodyTopStyle5(props) {

    const {
        pageNumber,
        totalPages,
        document,
        routeType,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.location_name ? document.location_name : "-"}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5
                }}
            >
                {
                    (routeType === routeTypes.admin) &&

                    <View>
                        <Text style={[styles.h7, { marginBottom: 5 }]}>
                            SUPPLIED BY:
                        </Text>
                        <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                            {document?.profile_name} ({document?.code})
                        </Text>
                        <Text style={[styles.h9, { width: '100%' }]}>
                            {document?.address_1} {document?.address_2}
                        </Text>
                        <Text style={[styles.h9, { width: '100%' }]}>
                            {document?.area} {document?.postcode} ({document?.state_name}, {document?.country_name})
                        </Text>
                    </View>
                }
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>

    )

}

// retail item receive & item transfer
export function BodyTopStyle6(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '64%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.location_name ? document.location_name : "-"}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>

    )

}

// delivery trips
export function BodyTopStyle7(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.location_name ? document.location_name : "-"}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5 }]}>
                    LOGISTIC:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.logistic_label}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5 }]}>
                    DRIVER:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.driver_name}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>

    )

}

// sales CN & DN
export function BodyTopStyle8(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '50%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.location_name ? document.location_name : "-"}
                </Text>
            </View>

            <View
                style={{
                    width: '50%',
                    flexWrap: 'wrap',
                    paddingVertical: 5
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5 }]}>
                    PLACED BY:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.profile_name} ({document?.code})
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.address_1} {document?.address_2}
                    <Text style={[styles.h9, { width: '100%' }]}>
                        {document?.area} {document?.postcode} ({document?.state_name}, {document?.country_name})
                    </Text>
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>

    )

}

// purchase return
export function BodyTopStyle9(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.location_name}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5 }]}>
                    SUPPLIER:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.profile_name}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.address_1} {document?.address_2}
                </Text>
                <Text style={[styles.h9, { width: '100%' }]}>
                    {document?.area_name} {document?.postcode} ({document?.state_name}, {document?.country_name})
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>

    )
}

// item relocate
export function BodyTopStyle10(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData,
        items
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.location_name}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>

        </View>

    )
}

// item issue && item adjustments
export function BodyTopStyle11(props) {

    const {
        pageNumber,
        totalPages,
        document,
        qrCodeData
    } = props;

    const infos = [
        {
            name: "Date",
            value: document?.doc_date
        },
    ]

    return (
        <View
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'left',
                // paddingBottom: 10,
                borderTopColor: '#000',
                borderTopStyle: 'solid',
                borderTopWidth: 0.5,
                borderBottomColor: '#000',
                borderBottomStyle: 'solid',
                borderBottomWidth: 0.5,
                marginTop: 5,
                height: 100,
            }}
        >
            <View
                style={{
                    width: '32%',
                    flexWrap: 'wrap',
                    paddingVertical: 5,
                    fontFamily: 'Times-Roman'
                }}
            >
                <Text style={[styles.h7, { marginBottom: 5, fontStyle: 'italic' }]}>
                    LOCATION:
                </Text>
                <Text style={[styles.h11, styles.textBold, styles.textUpperCase, { width: '100%' }]}>
                    {document?.location_name}
                </Text>
            </View>

            <View
                style={{
                    width: '32%',
                    // flex: 1
                    borderLeftStyle: 'solid',
                    borderLeftWidth: 0.5,
                    borderLeftColor: '#000',
                    paddingLeft: 5,
                    paddingVertical: 5
                }}
            >
                <View>
                    {
                        infos.map((i, index) => {
                            return (
                                <RenderBodyTopInfoRow key={index} name={i.name} value={i.value} />
                            )
                        })
                    }
                    <RenderBodyTopInfoRow name={`Page`} value={`${pageNumber} of ${totalPages}`} />
                </View>

                <RenderQrCode
                    data={qrCodeData}
                />

            </View>
        </View>
    )
}

